const homeEventsRU = {
    movieTime: {
        header: "<1>Время Кино</1>",
        body: "Ты вошел в спальню и увидел, что <1>wife</1> включила телевизор и выбирает фильм." +
            "<2/>" +
            "<3>Мы смотрим фильм?</3> Спросил ты. <1>wife</1> кинула на тебя безразличный взгляд." +
            "<4>Нет, только я. Но если хочешь, ты можешь сесть на другом конце и посмотреть тоже.</4>" +
            "<3>Эмм, окей...</3> Ты сел на другой конец комнаты и так вы начали смотреть фильм.\n" +
            "<5>Повысь отношения с {{wife}}, чтобы увидеть больше сцен.</5><6/><6/>" +
            "<7>Закончить просмотр</7>"
    },

    movieTimeWatchTogether: "<1>Время Кино</1>" +
        "Ты вошел в комнату и к тебе сразу подошла <2>wife</2>." +
        "<3>Что-то мне скучно, давай что-нибудь посмотрим?</3>" +
        "<4>Давай, почему нет.</4> Сказал ты, подходя к телевизору." +
        "<5/>" +
        "Вы выбрали фильм и приступили к просмотру.\n" +
        "Через какое-то время ты заметил, что <2>wife</2> начала постоянно крутиться и прижимать руки к груди." +
        "<4>Что такое? С тобой всё окей?</4> Спросил ты. <2>wife</2> отстранилась от тебя и провела руками по своей груди." +
        "<6/>" +
        "<3>Ощущение, что у меня болит грудь. Может скоро месячные?</3> Ты посмотрел, как она проводит рукой по своим сиськам и возбудился.\n\n" +
        "<7>Давай посмотрю (недоступно в данной версии)</7><8/>" +
        "<9>Может просто неудобно сидишь?</9>",

    movieTimeUncomfortable: "<1>Время Кино</1>" +
        "<2>Наверное ты просто неудобно сидишь, ложись ко мне на колени.</2> Предложил ты ей." +
        "<3>Хорошо, давай попробуем...</3>" +
        "<4/>" +
        "В таком положении вы продолжили смотреть фильм. Через некоторое время  <5>wife</5> тебе сказала:" +
        "<3>Да, ты был прав, грудь больше не тянет.</3><6/><6/>" +
        "<7>Закончить просмотр</7>",

    bedTime: {
        header: "<1>Время Сна</1>",
        body: "Ты вошел в комнату и увидел, что <1>wife</1> лежит на кровати." +
            "<2/>" +
            "<3>Что-то случилось? Почему ты лежишь?</3>" +
            "<4>Что, я уже полежать просто так не могу?</4> Спросила <5>nick</5> раздраженно." +
            "<3>Можешь, конечно... С тобой можно?</3>" +
            "<4>Можно, но только меня не трогай...</4>" +
            "Ты лег рядом с женой на кровать, продолжая смотреть на неё. Она отвернулась.\n" +
            "Так вы пролежали какое-то время.\n" +
            "<6>Повысь отношения с {{wife}}, чтобы увидеть больше сцен.</6><7/><7/>" +
            "<8>Встать</8>"
    },

    bedTimeTogether: "<1>Время Сна</1>" +
        "Ты вошел в комнату и увидел, что <2>wife</2> лежит на кровати." +
        "<3>Мне что-то захотелось полежать, давай со мной?</3> Спросила она у тебя." +
        "<4>С удовольствием.</4> Ты лег к ней и вы обнялись." +
        "<5/>" +
        "Вы пролежали так какое-то время, но тут у <2>wife</2> зазвонил телефон, который лежал где-то под кроватью. " +
        "Она высвободилась из твоих объятий и потянулась к нему. Тебе представился великолепный вид на задницу жены." +
        "<6/>" +
        "От увиденного ты возбудился." +
        "<3>Тихо, мама звонит.</3> Не меняя позиции сказала она.\n\n" +
        "<7>Шлепнуть её по заднице (недоступно в данной версии)</7><8/>" +
        "<9>Не мешать ей</9>",

    bedTimeTogetherLetHerSpeak: "<1>Время Сна</1>" +
        "Ты решил не мешать её разговору с матерью. Через какое-то время они договорили и она вернулась к тебе в объятия." +
        "<2/><3/>" +
        "<4>Встать</4>",

    walkTime: {
        header: "<1>Время Прогулки</1>",
        body: "Ты вошел в комнату и увидел, что <1>wife</1> куда-то собирается." +
            "<2/>" +
            "<3>Куда собираешься?</3>" +
            "<4>Подальше отсюда... Ладно, иду гулять...</4> С нежеланием ответила <1>wife</1>." +
            "<3>Тогда я с тобой пойду.</3>" +
            "<4>Хорошо, только давай не будем особо разговаривать, я устала...</4>" +
            "<3>Хорошо...</3>" +
            "Через некоторое время вы вышли на улицу и пошли гулять в соседний парк." +
            "<5/>" +
            "Каждый раз, как ты пытался взять <1>wife</1> за ручку или заговорить с ней, она не давала.\n" +
            "Через какое-то время начало темнеть.\n" +
            "<6>Повысь отношения с {{wife}}, чтобы увидеть больше сцен.</6><7/><7/>" +
            "<8>Пойти домой</8>"
    },

    walkTimeTogether: "<1>Время Прогулки</1>" +
        "Ты вошёл в комнату и увидел, что <2>wife</2> куда-то собирается." +
        "<3/>" +
        "<4>Мне что-то захотелось погулять, пойдём?</4>" +
        "<5>Да, пошли.</5>" +
        "Через какое-то время вы вышли и пошли в ближайший парк." +
        "<6/>" +
        "Вы всё время шли, державшись за ручку и о чем-то постоянно болтали.\nТак прошло полтора часа.\n" +
        "В один из моментов вы зашли в одно из мест парка, где постоянно проходит много народа, так как оно находится на пересечении дорожек.\n" +
        "Вот и в этот раз вас обогнала девушка с шикарной задницей." +
        "<7/>" +
        "Ты пытался всеми силами не бросить взгляд на её задницу, но ничего у тебя не вышло, и ты начал пялиться на неё." +
        "<4>{{player}}, ты куда смотришь? Ахренел что-ли совсем?</4> <8>nick</8> вырвала свою руку из твоей." +
        "<5>Да, нет... {{wife}}, ты не поняла... Я задумался...</5>" +
        "<4>Задумался о её заднице? Пошёл ты к черту, {{player}}</4>" +
        "Девушка краем уха услышала ваш разговор, повернулась и улыбнулась тебе.\n" +
        "Дальше вы шли без разговоров.\n" +
        "<9>Конец ивента в данной версии.</9><10/><10/>" +
        "<11>Пойти домой</11>",

    cookingTime: {
        header: "<1>Время Готовки</1>",
        body: "Ты вошёл в комнату и увидел, что <1>wife</1> сидит в компьютере. Ты решил её не тревожить и включить телек.\n" +
            "Спустя минут опять она встала, выключила компьютер и вышла из комнаты на кухню, ты решил последовать за ней." +
            "<2>Что будешь делать?</2> Спросил ты, входя на кухню. <1>wife</1> искала что-то в кухонной тумбе." +
            "<3>Готовить, что ещё я могу делать на кухне?</3> Съязвила <1>wife</1>, достав кастрюлю." +
            "<2>Тебе помочь?</2> Спросил ты." +
            "<3>Нет, спасибо, сама как-нибудь.</3> В этот момент у неё позвонил телефон." +
            "<4/>" +
            "Ответив на звонок, она продолжила готовить. " +
            "Всё оставшееся время она говорила по телефону, перемещая продукты и посуду по кухонному столу, как будто не замечая тебя.\n" +
            "<5>Повысь отношения с {{wife}}, чтобы увидеть больше сцен.</5><6/><6/>" +
            "<7>Отойти</7>"
    },

    cookingTimeTogether: "<1>Время Готовки</1>" +
        "Ты вошёл в комнату и увидел, что <2>wife</2> сидит в компьютере. Ты решил её не тревожить и включить телек.\n" +
        "Спустя минут опять она встала, выключила компьютер и сказал тебе:" +
        "<3>{{player}}, я иду готовить, поможешь мне?</3>" +
        "<4>С удовольствием.</4>" +
        "Вы пошли на кухню и приступили к готовке." +
        "<5/>" +
        "Всё время вы смеялись и болтали, из-за чего процесс несколько замедлился.\n" +
        "Через какое-то время из-за нескольких кипящих кастрюль на кухне стало очень душно." +
        "<4>Надо бы открыть окно, а то безумно душно...</4>" +
        "<3>Не надо, я могу простыть, ты же знаешь... Сними лучше свою кофту, а я пойду надену шорты.</3>" +
        "Она ушла и через какое-то время вернулась. " +
        "На ней были шорты, которые она практически никогда не надевала, так как они были слишком маленькие и не подходили для обычной жизни, как говорила <2>wife</2>." +
        "<6/>" +
        "<4>О, это те самые шорты...</4> Сказал ты, улыбнувшись." +
        "<3>Да, да, те самые шорты. Только прошу тебя, не трогай меня, нужно сосредоточиться на готовке, а то и так очень много времени потратили...</3>" +
        "Сказала <7>nick</7>, улыбнувшись. Она как будто читала твои мысли." +
        "<4>Да я даже не думал...</4> Сказал ты, смотря на её задницу, которая идеально смотрелась в этой одежде.\n" +
        "Вы продолжили готовить...\n" +
        "<8>Конец ивента в данной версии.</8><9/><9/>" +
        "<10>Закончить готовку</10>",

    dressingTime: {
        header: "<1>Время Переодевания</1>",
        body: "Ты вошел в комнату в самый подходящий момент: <1>wife</1> переодевалась." +
            "<2/>" +
            "Она услышала твои шаги уже из далека, поэтому отвернулась и сказала тебе:" +
            "<3>{{player}}, уйди, не видишь, я переодеваюсь?</3>" +
            "<4>Ок, прости.</4><5/>" +
            "<6>Увеличь отношения с {{wife}}, чтобы увидеть больше сцен.</6><5/><5/>" +
            "<7>Выйти из комнаты</7>"
    },

    dressingTimeWatch: "<1>Время Переодевания</1>" +
        "Ты вошел в комнату в самый подходящий момент: <2>wife</2> переодевалась.\n" +
        "Видимо, она не услышала, как ты подходишь, потому что когда ты вошел в комнату, она продолжила переодеваться." +
        "<3/>" +
        "Ты какое-то время понаблюдал за женой и возбудился.\n Долго думая, подойти к ней или нет, ты решил этого не делать.\n" +
        "<4>Конец ивента в данной версии.</4><5/><5/>" +
        "<6>Выйти из комнаты</6>"

};

export default homeEventsRU;